import { defineMessages } from "react-intl";

const messages = defineMessages({
    type: {
        id: "meta.type",
    },
    folksong: {
        id: "meta.folksong",
    },
    composer: {
        id: "meta.composer",
    },
    country: {
        id: "meta.country",
    },
    tempo: {
        id: "meta.tempo",
    },
    isLyrics: {
        id: "meta.isLyrics",
    },
    language: {
        id: "meta.language",
    },
    isAccompaniment: {
        id: "meta.isAccompaniment",
    },
    isCanon: {
        id: "meta.isCanon",
    },
    title: {
        id: "meta.title",
    },
    genre: {
        id: "meta.genre",
    },
    folksongClass: {
        id: "meta.folksongClass",
    },
    folksongTempo: {
        id: "meta.folksongTempo",
    },
    exerciseType: {
        id: "meta.exerciseType",
    },
    tempoFeel: {
        id: "meta.tempoFeel",
    },
    timeSignature: {
        id: "meta.timeSignature",
    },
    isUpbeat: {
        id: "meta.isUpbeat",
    },
    rhythmPatterns: {
        id: "meta.rhythmPatterns",
    },
    isRepeat: {
        id: "meta.isRepeat",
    },
    isSolfa: {
        id: "meta.isSolfa",
    },
    clef: {
        id: "meta.clef",
    },
    key: {
        id: "meta.key",
    },
    solfaNames: {
        id: "meta.solfaNames",
    },
    scale: {
        id: "meta.scale",
    },
    intervals: {
        id: "meta.intervals",
    },
    range: {
        id: "meta.range",
    },
    level: {
        id: "meta.level",
    },
    labels: {
        id: "meta.teaching.labels",
    },
    addNewComposer: {
        id: "newComposer.title",
    },
    articleTitle: {
        id: "article.meta.title",
    },
    articleDescription: {
        id: "article.meta.description",
    },
    articleOpusTitle: {
        id: "article.meta.opus.title",
    },
    articleOpusDescription: {
        id: "article.meta.opus.description",
    },
    articlePitchTitle: {
        id: "article.meta.pitch.title",
    },
    articlePitchDescription: {
        id: "article.meta.pitch.description",
    },
    articleRhythmTitle: {
        id: "article.meta.rhythm.title",
    },
    articleRhythmDescription: {
        id: "article.meta.rhythm.description",
    },
    articleTeachingTitle: {
        id: "article.meta.teaching.title",
    },
    articleTeachingDescription: {
        id: "article.meta.teaching.description",
    },
});

export default messages;
